import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type TimeRangeParams = { startTime: string; endTime: string };

export type SeriesResponse = {
  labels: string[];
  values: number[];
};

export type RatioResponse = {
  numerator: number;
  denominator: number;
  percentage: number; // 0-100
};

export type TotalResponse = {
  total: number;
};

const qs = (params: Record<string, string | number | undefined>) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) sp.append(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

const CommissionContractsStatisticsAPI = {
  getTotalRequests: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<TotalResponse>(
      `/v1/statistics/commission-contracts/summary/total${qs({ startTime, endTime })}`
    ),

  getTotalRequestsOverTime: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SeriesResponse>(
      `/v1/statistics/commission-contracts/summary/total-over-time${qs({ startTime, endTime })}`
    ),

  getTotalSales: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<TotalResponse>(
      `/v1/statistics/commission-contracts/summary/total-sales${qs({ startTime, endTime })}`
    ),

  getTotalSalesOverTime: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SeriesResponse>(
      `/v1/statistics/commission-contracts/summary/total-sales-over-time${qs({ startTime, endTime })}`
    ),

  getTotalInStore: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<TotalResponse>(
      `/v1/statistics/commission-contracts/summary/total-in-store${qs({ startTime, endTime })}`
    ),

  getTotalInStoreOverTime: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SeriesResponse>(
      `/v1/statistics/commission-contracts/summary/total-in-store-over-time${qs({ startTime, endTime })}`
    ),

  getSoldRatio: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<RatioResponse>(
      `/v1/statistics/commission-contracts/summary/sold-ratio${qs({ startTime, endTime })}`
    ),

  getReturnedRatio: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<RatioResponse>(
      `/v1/statistics/commission-contracts/summary/returned-ratio${qs({ startTime, endTime })}`
    ),

  getRejectedRatio: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<RatioResponse>(
      `/v1/statistics/commission-contracts/summary/rejected-ratio${qs({ startTime, endTime })}`
    ),
};

export default CommissionContractsStatisticsAPI;

